/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import { Tooltip } from "@mui/material";
import React from "react";
// eslint-disable-next-line react/prop-types
function Eye({ width = 23.467, height = 16, ...props }) {
  return (
    <Tooltip title="View" placement="top">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 23.467 16"
        {...props}
      >
        <path
          id="visibility_FILL0_wght400_GRAD0_opsz24"
          d="M12.733,16.8a4.778,4.778,0,0,0,4.8-4.8,4.778,4.778,0,0,0-4.8-4.8,4.778,4.778,0,0,0-4.8,4.8,4.778,4.778,0,0,0,4.8,4.8Zm0-1.92A2.87,2.87,0,0,1,9.853,12a2.868,2.868,0,0,1,2.88-2.88A2.866,2.866,0,0,1,15.613,12a2.868,2.868,0,0,1-2.88,2.88Zm0,5.12A12.347,12.347,0,0,1,5.64,17.826,12.351,12.351,0,0,1,1,12,12.555,12.555,0,0,1,12.733,4a12.555,12.555,0,0,1,11.733,8,12.351,12.351,0,0,1-4.64,5.826A12.347,12.347,0,0,1,12.733,20ZM12.733,12Zm0,5.867a10.181,10.181,0,0,0,5.534-1.587A10.422,10.422,0,0,0,22.12,12a10.429,10.429,0,0,0-3.853-4.281,10.186,10.186,0,0,0-5.534-1.586A10.186,10.186,0,0,0,7.2,7.719,10.429,10.429,0,0,0,3.347,12,10.422,10.422,0,0,0,7.2,16.279,10.181,10.181,0,0,0,12.733,17.867Z"
          transform="translate(-1 -4)"
          fill="#8c8c8c"
        />
      </svg>
    </Tooltip>
  );
}
export default Eye;
